import FootballState from "../../../../../sports/football/state/football-state";
import { FragmentSerializer } from "./FragmentSerializer";

export class PassFragmentSerializer extends FragmentSerializer {
    getRawFragment(play, serializationContext, pass) {
        const passComplete = play.getFirstFragment(FootballState.PassComplete);
        const passIntercepted = play.getFirstFragment(
            FootballState.PassIntercepted
        );
        const passSacked = play.getFirstFragment(FootballState.PassSacked);
        const passDropped = play.getFirstFragment(FootballState.PassDropped);
        const passIncomplete = play.getFirstFragment(
            FootballState.PassIncomplete
        );
        const passBrokenUp = play.getFirstFragment(FootballState.PassBrokenUp);
        const passFumble = play.getFirstFragment(FootballState.Fumble);
        const passFumbleRecovery =
            play.getFirstFragment(FootballState.FumbleRecovered) ||
            play.getFirstFragment(FootballState.FumbleNotRecovered);

        const hitReboundNet = play.getFirstFragment(
            FootballState.HitReboundNet
        );

        let passResultCode =
            passComplete?.passResultCode ||
            passIntercepted?.passResultCode ||
            passSacked?.passResultCode ||
            passDropped?.passResultCode ||
            passIncomplete?.passResultCode ||
            passBrokenUp?.passResultCode ||
            passFumble?.passResultCode;

        if (!passResultCode && hitReboundNet) {
            passResultCode = "I"; // Incomplete — ball hit the rebound net
        }

        let values = [
            this.resolveUniform(serializationContext, pass.passedBy),
            passResultCode
        ];

        if (passComplete || passIntercepted || passSacked || passFumble) {
            const [player] =
                passComplete?.getPlayers() ||
                passIntercepted?.getPlayers() ||
                passSacked?.getPlayers() ||
                passFumbleRecovery?.getPlayers() ||
                [];

            const fieldPosition =
                passComplete?.getFieldPosition() ||
                passIntercepted?.getFieldPosition() ||
                passSacked?.getFieldPosition() ||
                passFumbleRecovery?.getFieldPosition() ||
                0;

            const formattedFieldPosition = this.resolveFormattedFieldPosition(
                serializationContext,
                fieldPosition
            );

            values = [
                ...values,
                this.resolveUniform(serializationContext, player) || "TM",
                formattedFieldPosition
            ];
        } else if (passIncomplete || passDropped || passBrokenUp) {
            const [player] =
                passIncomplete?.getPlayers() ||
                passDropped?.getPlayers() ||
                passBrokenUp?.getPlayers() ||
                [];

            values = [
                ...values,
                this.resolveUniform(serializationContext, player),
                "*"
            ];
        }
        let rawFragment = `PASS:${values.join()}`;

        if (passIntercepted) {
            const interceptValues = [
                this.resolveUniform(
                    serializationContext,
                    passIntercepted.returnedBy
                ) || "TM",
                this.resolveFormattedFieldPosition(
                    serializationContext,
                    passIntercepted.returnedAt
                )
            ];

            rawFragment += ` RET:${interceptValues.join()}`;
        }

        return rawFragment;
    }

    applicable(fragment) {
        return fragment.associatedState === FootballState.Pass;
    }

    getTypeCode(fragment) {
        return fragment.passType?.code;
    }
}
